// Per-CLIENT static overrides. Keyed by the CLIENT env value (set at build time
// via craco — see craco.config.js DefinePlugin).
//
// Add an entry here when a client needs to diverge from main src behaviour
// (SSO type, API URLs, per-client feature flags). Anything not listed falls
// back to the `default` profile.

const CLIENT = process.env.CLIENT || 'web';

const clientConfigs = {
  default: {
    ssoType: 'visit',
  },
  mibl: {
    ssoType: 'universal',
    apiBaseUrl: {
      staging: 'https://insurance-uat.getvisitapp.net/loki',
      development: 'https://api.samuraijack.xyz/latios',
    },
    pharmaServer: {
      staging: 'https://api.getvisitapp.net/agni',
    },
  },
  sencov: {
    ssoType: 'universal',
    apiBaseUrl: {
      staging: 'https://api.samuraijack.xyz/latios',
      development: 'https://api.samuraijack.xyz/latios',
    },
    pharmaServer: {
      staging: 'https://api.getvisitapp.net/agni',
    },
    myntraSponsorIds: [18860],
    showForYouSection: [14, 77],
    useDopeRelatives: true,
  },
};

const clientConfig = clientConfigs[CLIENT] || clientConfigs.default;

export const CLIENT_NAME = CLIENT;
export default clientConfig;
